import React from "react";
import HeroCertified from "./HeroCertified";
import CertificateGallery from "./CertificateGallery";

export default function Certified() {
  return (
    <div>
      <HeroCertified />
        <CertificateGallery />
      {/* Add more sections/components related to Certified if needed */}
    </div>
  );
}